import type { Editor } from '@tiptap/core';
import { ReactRenderer } from '@tiptap/react';
import type { SuggestionKeyDownProps, SuggestionProps } from '@tiptap/suggestion';

import { EmojiSuggestionList } from './EmojiSuggestionList';

export const emojiSuggestion = {
  items: ({ editor, query }: { editor: Editor; query: string }) => {
    const q = query.toLowerCase();
    return editor.storage.emoji.emojis
      .filter(
        ({ shortcodes, tags }: { shortcodes: string[]; tags: string[] }) =>
          shortcodes.some((s: string) => s.startsWith(q)) || tags.some((t: string) => t.startsWith(q)),
      )
      .slice(0, 20);
  },

  allowSpaces: false,

  render: () => {
    let component: ReactRenderer | null = null;

    return {
      onStart: (props: SuggestionProps) => {
        component = new ReactRenderer(EmojiSuggestionList, {
          props,
          editor: props.editor,
        });
      },

      onUpdate: (props: SuggestionProps) => {
        component?.updateProps(props);
      },

      onKeyDown: (props: SuggestionKeyDownProps) => {
        if (props.event.key === 'Escape') {
          component?.destroy();
          component = null;
          return true;
        }

        return (
          (component?.ref as { onKeyDown: (event: KeyboardEvent) => boolean } | null)?.onKeyDown(props.event) ?? false
        );
      },

      onExit: () => {
        component?.destroy();
        component = null;
      },
    };
  },
};
